import { AgGrid } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";
import { ExternalLinkCountCellRenderer } from "../ExternalLinkCountCellRenderer";

export const ActiveCasesCellRenderer = ({ data }: AgGrid.ICellRendererParams) => {
  const activeCaseIds =
    data?.activeCaseIds ??
    data?.activeCases?.map((caseInfo: { id: number }) => caseInfo.id) ??
    [];

  return (
    <ExternalLinkCountCellRenderer
      count={activeCaseIds.length}
      launchLink={`${globalEnv.complianceRoute}?caseIds=${activeCaseIds.join(",")}`}
      tooltipContent="View cases"
      testIdPrefix="view-active-cases"
    />
  );
};
